import { Card, CardContent } from '@mui/material'

const formatDate = (date) => {
  if (!date) return 'Não informada'

  const [year, month, day] = date.split('-')
  if (!year || !month || !day) return 'Data inválida'

  return `${day}/${month}/${year}`
}

const ExpiredDocumentsList = ({ documents }) => {
  return (
    <div className="flex flex-col gap-2 mt-2">
      {documents.map((document) => (
        <Card key={document.id}>
          <CardContent>
            <h2 className="font-semibold text-base mb-3">{document.name}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <p className="text-xs opacity-70">Data de emissão</p>
                <p className="font-medium">{formatDate(document.issueDate)}</p>
              </div>
              <div>
                <p className="text-xs opacity-70">Data de vencimento</p>
                <p className="font-medium text-danger">
                  {formatDate(document.expirationDate)}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

export default ExpiredDocumentsList
